import * as constants from './constants'
import { get } from 'request/index'
import { message } from 'antd'
import { getUserBalance } from 'request/finance'

export const setMenuCollapsed = () => ({ type: constants.MENU_COLLAPSED })
export const setLoginStatus = value => ({ type: constants.CHANGE_LOGIN_STATUS, value })
export const setAllEnum = value => ({ type: constants.SET_ALL_ENUM, value })
export const setLoginUser = value => ({ type: constants.SET_LOGIN_USER, value })
export const setPersonalize = value => ({ type: constants.SET_PERSONALIZE, value })
export const setBreadcrumb = value => ({ type: constants.SET_BREADCRUMB, value })
export const setBalance = value => ({type: constants.SET_BALANCE, value})

export const getLoginUser = () => {
  return dispatch => {
    get('/info').then(res => {
      if (res.success) {
        dispatch(setLoginUser(res.data))
      } else if (res.code !== '401') {
        message.error('获取用户信息失败')
      }
    })
  }
}

export const getPersonalize = () => {
  return dispatch => {
    get('/personalize/get').then(res => {
      if (res.success) {
        dispatch(setPersonalize(res.data))
      } else if (res.code !== '401') {
        message.error('获取用户信息失败')
      }
    })
  }
}

export const getAllEnum = () => {
  return dispatch => {
    get('/enum/getAll').then(res => {
      if (res.success) {
        dispatch(setAllEnum(res.data))
      } else if (res.code !== '401') {
        message.error('获取信息失败')
      }
    })
  }
}

export const updateBalance = () => {
  return async dispatch => {
    try {
      const {success, data} = await getUserBalance()
      if (!success) {
        message.error('获取余额失败')
        return false
      }
      dispatch(setBalance(data.balance))
    } catch (e) {
      message.error('获取余额失败')
    }
  }
}
